export function getProjects(state: any) {
    return state.projectsPage.list.rows;
}

export function getProjectsMeta(state: any) {
    return state.projectsPage.list.meta;
}

export function getProjectsParams(state: any) {
    return state.projectsPage.listParams;
}

export function getFilterYears(state: any) {
    return state.projectsPage.filters.years;
}

export function hasMoreProjects(state: any) {
    const rows = getProjects(state);
    const meta = getProjectsMeta(state);

    return meta.totalSize > rows.length;
}

export function isLoading(state: any) {
    return state.projectsPage.isLoading;
}
